import { AfterViewChecked, Directive, ElementRef, Renderer2 } from '@angular/core';
import { LinkService } from '../../services/link/link.service';

@Directive({
    selector: '[paceCoreLink]',
})
export class LinkDirective implements AfterViewChecked {
    public content = '';
    public paceLinksDestroyers: Array<() => void>;
    public constructor(
        private readonly el: ElementRef<HTMLElement>,
        private readonly renderer: Renderer2,
        private readonly linkService: LinkService,
    ) {}

    // this function is being used to attach listeners to <a> tags from innerHtml text.
    // we use this lifecycle hook, as this is the only hook which gets triggered after the content of the innerHtml has been changed
    // we need to destroy listeners for non-existing innerHtml <a> tags, when the view is changing
    // afterwards we need to add listeners for the new links(if existing)
    public ngAfterViewChecked(): void {
        const elementContent = this.el.nativeElement.innerHTML;

        // we are comparing the content with the previous known content to add listeners to the links, only if the content changes.
        if (this.content !== elementContent) {
            if (Array.isArray(this.paceLinksDestroyers) && this.paceLinksDestroyers.length > 0) {
                this.paceLinksDestroyers.forEach((paceLinkDestroyer) => paceLinkDestroyer());
            }

            const paceLinks = this.el.nativeElement.getElementsByClassName('pace-link');
            if (paceLinks && paceLinks.length > 0) {
                this.paceLinksDestroyers = Array.from(paceLinks).map((paceLink) => {
                    const url = this.extractUrlFromElement(paceLink);

                    if (paceLink instanceof HTMLAnchorElement && paceLink.hasAttribute('target')) {
                        return (): void => {};
                    }

                    return this.renderer.listen(paceLink, 'click', () => this.linkService.openLink(url));
                });
            }

            this.content = elementContent;
        }
    }

    public extractUrlFromElement(paceLink: Element): string {
        const href = paceLink.getAttribute('href');

        return href === null ? paceLink.innerHTML : href;
    }
}
